//export const mainUrl = 'http://localhost:3005/api/v1/';
export const mainUrl = 'https://api.imilk.in/api/v1/';
